import React from 'react';

function Marquee() {
  return (
    <section className="marquee-action section-padding sub-bg radius-30 mt-15 o-hidden">
      <div className="container-fluid">
        <div className="main-marq xlrg text-u">
          <div className="slide-har st1">
            <div className="box">
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Get In Touch</a>
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Contact Us</a>{' '}
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Get In Touch</a>
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Contact Us</a>{' '}
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Get In Touch</a>
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Contact Us</a>{' '}
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
            </div>
            <div className="box">
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Get In Touch</a>
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Contact Us</a>{' '}
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Get In Touch</a>
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Contact Us</a>{' '}
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Get In Touch</a>
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="d-flex align-items-center fw-800">
                  <a href="/dark/page-contact2">Contact Us</a>{' '}
                  <span className="fz-50 ml-50 stroke icon">*</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Marquee;
